// extracted by css-extract-rspack-plugin
export default {"snapOverlay":"src-modules-desktop-pages-MainPage-components-WindowManager-components-Window-components-SnapOverlay-SnapOverlay-module__snapOverlay-bJL5su"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"snapOverlay\":\"src-modules-desktop-pages-MainPage-components-WindowManager-components-Window-components-SnapOverlay-SnapOverlay-module__snapOverlay-bJL5su\"}";
        // 1793874325554
        var cssReload = require("../../../../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  